// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1906w","top":"styles_top__1YjC6"};